import get from "lodash/get";
import i18n from "../i18n";
import { ZIPREG } from "../constants";

const Billing = (app) => {
  app
    // Update credit card info
    .post(
      "/billing/update/source",
      async ({ req, res, api, flash, assert }) => {
        const { body } = req;

        assert(
          process.browser,
          400,
          i18n.t("dashboard:billing.unableToProcessBrowser")
        );
        assert(body.source, 400, i18n.t("dashboard:billing.fillFormRequired"));

        // Validations
        if (get(body, "source.address_zip", false)) {
          const zipPattern = ZIPREG[body.source.address_country];
          if (zipPattern)
            assert(
              zipPattern.test(body.source.address_zip),
              400,
              i18n.t("dashboard:billing.invalidZip")
            );
        }

        if (get(body, "source.address_line1", false)) {
          assert(
            body.source.address_city,
            400,
            i18n.t("dashboard:billing.cityRequired")
          );
          assert(
            body.source.address_zip,
            400,
            i18n.t("dashboard:billing.zipRequired")
          );
          assert(
            body.source.address_country,
            400,
            i18n.t("dashboard:billing.countryRequired")
          );
        }

        const addressInfo = {
          addressLine1: body.source.address_line1,
          addressLine2: body.source.address_line2,
          addressCity: body.source.address_city,
          addressState: body.source.address_state,
          addressZip: body.source.address_zip,
          addressCountry: body.source.address_country,
        };

        if (body.stripeToken) {
          body.source = body.stripeToken.token;
        }

        Object.assign(body.source, addressInfo);
        // If no new card is provided, perform the same action as updating just the address
        if (!body.stripeToken) {
          await api(`user-update-billing-address`, { method: "PUT", body });
        } else {
          await api(`user-update-billing-info`, { method: "PUT", body });
        }
        flash("success", i18n.t("dashboard:billing.creditCardUpdated"));
        res.redirect("/dashboard/settings/billing?closeEditCredit=true");
      }
    )
    // Update coach credit card info
    .post(
      "/coach-billing/update/source",
      async ({ req, res, api, flash, assert }) => {
        const { body } = req;

        assert(
          process.browser,
          400,
          i18n.t("dashboard:billing.unableToProcessBrowser")
        );
        assert(body.source, 400, i18n.t("dashboard:billing.fillFormRequired"));

        // Validations
        if (get(body, "source.address_zip", false)) {
          const zipPattern = ZIPREG[body.source.address_country];
          if (zipPattern)
            assert(
              zipPattern.test(body.source.address_zip),
              400,
              i18n.t("dashboard:billing.invalidZip")
            );
        }

        if (get(body, "source.address_line1", false)) {
          assert(
            body.source.address_city,
            400,
            i18n.t("dashboard:billing.cityRequired")
          );
          assert(
            body.source.address_zip,
            400,
            i18n.t("dashboard:billing.zipRequired")
          );
          assert(
            body.source.address_country,
            400,
            i18n.t("dashboard:billing.countryRequired")
          );
        }

        if (body.stripeToken) {
          body.source = body.stripeToken.token;
        }

        // If no new card is provided, perform the same action as updating just the address
        if (!body.stripeToken) {
          await api(`coach-update-billing-address`, { method: "PUT", body });
        } else {
          await api(`coach-update-billing-info`, { method: "PUT", body });
        }
        flash("success", i18n.t("dashboard:billing.creditCardUpdated"));
        res.redirect(
          "/coaching-portal/settings/coach-manage-billing?closeEditCredit=true"
        );
      }
    )
    .post("/billing/perform", async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        await (
          await api(
            `stripe-create-perform-subscription?user=${locals.activeUser._id}`,
            {
              method: "PUT",
              body: { stripeToken: body.stripeToken },
            }
          )
        ).json();

        flash("success", "Your PERFORM subscription has been activated!");
        res.redirect("/coaching-portal/access-requests");
      } catch (e) {
        console.log("error", e);
        flash("error", e.message);
        res.refreshWith({}, { url: "back" });
      }
    })
    .post("/billing/coach", async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      // call the api to attach the source to the stripe user
      try {
        await (
          await api(`stripe-attach-source?user=${locals.activeUser._id}`, {
            method: "PUT",
            body: body,
          })
        ).json();

        // flash success update to the user
        flash("success", i18n.t("dashboard:billing.accountActivated"));

        res.redirect("/coaching-portal");
      } catch (e) {
        console.log("error", e);
        flash("error", e.message);
        res.refreshWith({}, { url: "back" });
      }
    });
};

export default Billing;
